<template>
  <div
    class="direction-column flex min-h-screen w-full flex-col items-center justify-center"
  >
    <slot />
  </div>
</template>
